import { StaffService } from './../../_services/staff.service';
import { PaginationInfo } from './../../_models/pagination-info';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../_services/global.service';
import { CourseService } from '../../_services/course.service';
import { ResponseStructure } from '@iq-central-front-end/share';

@Component({
  selector: 'iq-central-front-end-my-learning',
  templateUrl: './my-learning.component.html',
  styleUrls: ['./my-learning.component.scss'],
})
export class MyLearningComponent implements OnInit {
  empty;
  courses;
  assignedCourses: any[] = [];
  assignedCoursesPaginationInfo: PaginationInfo;
  enrolledCourses: any[] = [];
  savedCourses: any[] = [];
  enrolledCoursesPaginationInfo: PaginationInfo;
  assignedLpPaginationInfo: PaginationInfo;
  savedCoursesPaginationInfo: PaginationInfo;
  currentDate: Date = new Date();
  assignedLp: any[] = [];
  sub: Subscription = new Subscription();
  constructor(
    private _global: GlobalService,
    private route: ActivatedRoute,
    private _staff: StaffService,
    private _courses: CourseService
  ) {}

  ngOnInit(): void {
    this.empty = false;
    this.getResolvedData();
  }

  getResolvedData() {
    this.sub.add(
      this.route.data.subscribe((res) => {
        this._global.hideSpinner();
        this.assignedCourses =
          res['resolvedData'].courses['responseResult'].assignedCourses;
        this.assignedCoursesPaginationInfo =
          res['resolvedData'].courses['responseResult'].paginationInfo;
        this.assignedLp =
          res['resolvedData'].learningPath['responseResult'].learningPaths;
        this.assignedLpPaginationInfo =
          res['resolvedData'].learningPath['responseResult'].paginationInfo;

        this.enrolledCourses =
          res['resolvedData'].enrolledCourses['responseResult'].courses;
        this.enrolledCoursesPaginationInfo =
          res['resolvedData'].enrolledCourses['responseResult'].paginationInfo;
        this.savedCourses =
          res['resolvedData'].savedCourses['responseResult'].courses;
        this.savedCoursesPaginationInfo =
          res['resolvedData'].savedCourses['responseResult'].paginationInfo;
      })
    );
  }

  diff_weeks(dt1) {
    console.log(diff);
    var diff = (this.currentDate.getTime() - dt1.getTime()) / 1000;

    diff /= 60 * 60 * 24 * 7;
    return Math.abs(Math.round(diff));
  }

  transformDuration(index): string {
    let duration = this.assignedCourses[index].course['duration'];
    const transformedDuration = duration.split(':');
    return transformedDuration[0] + 'Hrs:' + transformedDuration[1] + 'Mins';
  }
  transformSDuration(index): string {
    let duration = this.savedCourses[index].duration;
    const transformedDuration = duration.split(':');
    return transformedDuration[0] + 'Hrs:' + transformedDuration[1] + 'Mins';
  }

  navigateEnrolledCoursePage(page) {
    this._global.showSpinner();
    this._staff.getEnrolledCourses(page, 8).subscribe({
      next: (response) => {
        this._global.hideSpinner();
        this.enrolledCourses = response['responseResult'].assignedCourses;
        this.enrolledCoursesPaginationInfo =
          response['responseResult'].paginationInfo;
      },
    });
  }

  navigateLpPage(page) {
    this._global.showSpinner();
    this._staff.getAssignedLearningPath(page, 8).subscribe({
      next: (response) => {
        this._global.hideSpinner();
        this.assignedLp = response['responseResult'].assignedCourses;
        this.assignedCoursesPaginationInfo =
          response['responseResult'].paginationInfo;
      },
    });
  }
  navigateAssignedCoursePage(page) {
    this._global.showSpinner();
    this._staff.getAssignedCourses(page, 8).subscribe({
      next: (response) => {
        this._global.hideSpinner();
        this.assignedCourses = response['responseResult'].assignedCourses;
        this.assignedCoursesPaginationInfo =
          response['responseResult'].paginationInfo;
      },
    });
  }

  navigateSavedCoursePage(page) {
    this._global.showSpinner();
    this._courses.savedCourses(page, 8).subscribe({
      next: (response) => {
        this._global.hideSpinner();
        this.savedCourses = response['responseResult'].courses;
        this.savedCoursesPaginationInfo =
          response['responseResult'].paginationInfo;
      },
    });
  }

  removeSavedCourse(course) {
    const payload = this.savedCourses;
    this.sub.remove(
      this._courses.toggleSavedCourse(course.code, payload).subscribe({
        next: (res: ResponseStructure) => {
          this.savedCourses = this.savedCourses.filter(
            (m) => m.id !== course.id
          );
          this._global.globalSuccessHandler(res);
        },
      })
    );
  }
  z;
}
